import * as apis from './apis';

export * from './types';

const LivepeerModel = {
    ...apis,
}

export default LivepeerModel;
